import { useAppDispatch, useAppSelector } from '@store/hooks'
import { updateProgram } from '@store/membership/ProgramReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'

import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import Update from './Update'

export const ProgramForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.program)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        update: Update,
      }}
      handlers={{
        update: async (values) =>
          dispatch(
            updateProgram({
              ...values,
              whatsappNumber:
                values.whatsappNumber &&
                formatPhoneNumberToE164FromPhoneInput(values.whatsappNumber),
            })
          ).then(() => {
            return true
          }),
      }}
    />
  )
})

ProgramForm.displayName = 'ProgramForm'

export default ProgramForm
